
/**
 * SimpleTree is a simple implementation of a tree data structure
 */

class SimpleTree {
    constructor(children) {
        this.children = children;
    }

    getAllLeaves() {
        if (this.children === undefined) {
            return [this];
        }

        let leaves = [];
        for (let i in this.children) {
            leaves = leaves.concat(this.children[i].getAllLeaves());
        }

        return leaves;
    }

    getLeftMostLeaf() {
        let leaves = this.getAllLeaves();
        if (leaves.length > 0) {
            return leaves[0];
        }

        return undefined;
    }
}

export default SimpleTree;
